import { render, staticRenderFns } from "./RmpBtn.vue?vue&type=template&id=5b14fbbc"
import script from "./RmpBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpBtn.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports